export default __webpack_public_path__ + "static/media/ADIZ_01_mos_SAMF.d3bcbbc9.wav";